import { defineComponent as _defineComponent } from 'vue';
import { vModelText as _vModelText, withKeys as _withKeys, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, withDirectives as _withDirectives, unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, Teleport as _Teleport, createBlock as _createBlock, Fragment as _Fragment } from "vue";
const _hoisted_1 = ["placeholder"];
const _hoisted_2 = {
    key: 0,
    class: "shSearch-glue"
};
import { ThemeIcon } from '../../front/components';
import SiteSearch from '../../front/components/SiteSearch/SiteSearch.vue';
import { computed, onBeforeUnmount, onMounted, ref, watch } from 'vue';
import { useI18n } from 'vue-i18n';
export default /*#__PURE__*/ _defineComponent({
    __name: 'SHSearchApp',
    props: {
        searchControleMountPoint: {},
        report: {}
    },
    setup(__props, { expose: __expose }) {
        const { t } = useI18n();
        const props = __props;
        const searchQuery = ref('');
        const siteSearch = ref();
        const searchInputEl = ref();
        const inputContainerEl = ref();
        const mainEl = ref();
        const inputFocused = ref(false);
        const resultsVisible = computed(() => searchQuery.value.length > 0);
        const searchActive = computed(() => inputFocused.value || resultsVisible.value);
        onMounted(() => {
            document.addEventListener('click', onOutsideClick);
        });
        onBeforeUnmount(() => {
            document.removeEventListener('click', onOutsideClick);
        });
        __expose({
            get resultsVisible() {
                return resultsVisible.value;
            },
        });
        watch(() => searchActive.value, (next, prev) => {
            var _a, _b;
            if (next !== prev) {
                (_b = (_a = props.report) === null || _a === void 0 ? void 0 : _a.searchActive) === null || _b === void 0 ? void 0 : _b.call(_a, next);
            }
        });
        watch(() => resultsVisible.value, (next, prev) => {
            var _a, _b;
            if (next !== prev) {
                (_b = (_a = props.report) === null || _a === void 0 ? void 0 : _a.resultsVisible) === null || _b === void 0 ? void 0 : _b.call(_a, next);
            }
        });
        watch(() => searchQuery.value, (next, prev) => {
            var _a, _b;
            if (next !== prev) {
                (_b = (_a = props.report) === null || _a === void 0 ? void 0 : _a.searchQuery) === null || _b === void 0 ? void 0 : _b.call(_a, next);
            }
        });
        function onOutsideClick(event) {
            var _a, _b, _c;
            const target = event.target;
            if (searchQuery.value &&
                !((_a = inputContainerEl.value) === null || _a === void 0 ? void 0 : _a.contains(target)) &&
                !((_b = mainEl.value) === null || _b === void 0 ? void 0 : _b.contains(target)) &&
                !((_c = searchInputEl.value) === null || _c === void 0 ? void 0 : _c.contains(target))) {
                searchQuery.value = '';
            }
        }
        function maybeJumpToSiteSearch(event) {
            var _a;
            if (resultsVisible.value) {
                event.preventDefault();
                (_a = siteSearch.value) === null || _a === void 0 ? void 0 : _a.focus();
            }
        }
        function maybeOpenSearchPage() {
            if (searchQuery.value) {
                const url = t('search.search_url', { search_input: searchQuery.value });
                if (url && url.indexOf(window.location.origin) >= 0) {
                    window.location.href = url;
                }
            }
        }
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock(_Fragment, null, [
                (_openBlock(), _createBlock(_Teleport, { to: _ctx.searchControleMountPoint }, [
                    _createElementVNode("div", {
                        ref_key: "inputContainerEl",
                        ref: inputContainerEl
                    }, [
                        _withDirectives(_createElementVNode("input", {
                            type: "search",
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((searchQuery).value = $event)),
                            ref_key: "searchInputEl",
                            ref: searchInputEl,
                            class: _normalizeClass({ 'is--active': resultsVisible.value }),
                            placeholder: _ctx.$t('search.placeholder'),
                            onKeydown: [
                                _withKeys(maybeJumpToSiteSearch, ["tab"]),
                                _cache[3] || (_cache[3] = _withKeys(($event) => (searchQuery.value = ''), ["esc"])),
                                _withKeys(maybeOpenSearchPage, ["enter"])
                            ],
                            onFocus: _cache[1] || (_cache[1] = ($event) => (inputFocused.value = true)),
                            onBlur: _cache[2] || (_cache[2] = ($event) => (inputFocused.value = false))
                        }, null, 42, _hoisted_1), [
                            [_vModelText, searchQuery.value]
                        ]),
                        _createVNode(_unref(ThemeIcon), { name: "magnifying-glass" }),
                        _createVNode(_Transition, { name: "glue" }, {
                            default: _withCtx(() => [
                                (resultsVisible.value)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_2))
                                    : _createCommentVNode("", true)
                            ]),
                            _: 1
                        })
                    ], 512)
                ], 8, ["to"])),
                _createVNode(_Transition, { name: "main" }, {
                    default: _withCtx(() => [
                        (resultsVisible.value)
                            ? (_openBlock(), _createElementBlock("div", {
                                key: 0,
                                class: "shSearch-main container",
                                ref_key: "mainEl",
                                ref: mainEl,
                                onKeydown: _cache[4] || (_cache[4] = _withKeys(($event) => (searchQuery.value = ''), ["esc"]))
                            }, [
                                _createVNode(SiteSearch, {
                                    "without-input": true,
                                    query: searchQuery.value,
                                    leadToSearchPage: true,
                                    ref_key: "siteSearch",
                                    ref: siteSearch
                                }, null, 8, ["query"])
                            ], 544))
                            : _createCommentVNode("", true)
                    ]),
                    _: 1
                })
            ], 64));
        };
    }
});
